/* React hooks */
import {useEffect, useRef, useState} from "react";
/* Components */
import useData from "../../hooks/useData";
import {updateFunerariumAddressInfos,} from "../../api/pro/funerariumReq";
import useAuth from "../../hooks/useAuth";
import jwt_decode from "jwt-decode";
import InputFullAddress from "../../components/common/input-layout/InputFullAddress";
import FormButtons from "../../components/common/FormButtons";
import {checkRequiredFields, getErrorListFromValidation, removeErrorList, validateFormInput} from "../../helper/tools";
import Icon from "../../components/common/Icon";


export default function FormFunerariumAddress({ apiFunerariumGeneralInfos, legend, setShowModal }) {
    const { funerariumInfos } = useData();
    const { auth } = useAuth();
    const decodedToken = jwt_decode(auth.token);
    const agencyId = decodedToken.agency;
    const token = auth.token;
    const [ values, setValues ] = useState();
    const hasLoadedInfosRef = useRef(false);

    const onChange = (e) => {
        setValues({...values, address: {...values?.address, [e.target.name] : e.target.value}})
        validateFormInput(e)
    };

    // Ne pré-remplir le formulaire qu'au tout premier chargement des vraies données (funerariumInfos
    // vaut [] tant que la requête initiale n'a pas abouti) : si cet effet se redéclenchait plus tard
    // (ex: funerariumInfos rafraîchi en arrière-plan), il écraserait silencieusement la saisie en
    // cours de l'utilisateur.
    useEffect(() => {
        if (!hasLoadedInfosRef.current && funerariumInfos && !Array.isArray(funerariumInfos)) {
            setValues(funerariumInfos);
            hasLoadedInfosRef.current = true;
        }
    }, [ funerariumInfos ]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!checkRequiredFields()) {
            return;
        }
        let body = {
            agencyId : agencyId,
            addressId : values?.address?.addressId || 0,
            address : values?.address?.address,
            addressComp : values?.address?.addressComp,
            zipcode : values?.address?.zipcode,
            city : values?.address?.city,
            country : values?.address?.country,
        }
        await updateFunerariumAddressInfos(token, body)
            .then(response => {
                removeErrorList();
                if (!response?.response?.data?.error) {
                    setShowModal(false);
                    apiFunerariumGeneralInfos()
                } else {
                    getErrorListFromValidation(response?.response?.data?.error);
                }
            })
    }

    const handleRemoveModal = () => {
        setShowModal(false)
    }

    return (
        <form onSubmit={handleSubmit} method="POST" noValidate>
            <fieldset>
                {(legend !== "no-legend") && <Icon span={legend} source="fa fa-location-dot" />}
                <InputFullAddress
                    addressField="address"
                    compField="addressComp"
                    zipField="zipcode"
                    cityField="city"
                    countryField="country"
                    address={values?.address?.address}
                    comp={values?.address?.addressComp}
                    zipcode={values?.address?.zipcode}
                    city={values?.address?.city}
                    country={values?.address?.country || "FR"}
                    onChange={onChange}
                />
                <div className="errors"></div>
            </fieldset>
            <FormButtons handleRemoveModal={handleRemoveModal}/>
        </form>
    )
}